export default {
  SET_ITEMS(state, items) {
debugger;
    state.ComplaintSuggestions = items || [];
  },
  ADD_ITEM(state, item) {
    state.ComplaintSuggestions.unshift(item);
  },
  UPDATE_ITEM(state, item) {
    const index = state.ComplaintSuggestions.findIndex(x => x.ID === item.ID);
    if (index !== -1) state.ComplaintSuggestions.splice(index, 1, item);
  },
    GET_ITEM_BY_ID(state, Complaint){
  
    try {
      //const parsedData = JSON.parse(Complaint.data);

      state.Complaint = Complaint;
    } catch (error) {
      console.error("Failed to parse Complaint data JSON:", error);
      state.Complaint = {};
    }
  },
  REMOVE_ITEM(state, id) {
    state.ComplaintSuggestions = state.ComplaintSuggestions.filter(x => x.ID !== id);
  }

};
